import { createContext, useContext, useEffect, useState } from "react";
import { T, LANGUAGES } from "./translations";

const Ctx = createContext(null);

const detect = () => {
  const url = new URLSearchParams(window.location.search).get("lang");
  if (url && T[url]) return url;
  const saved = localStorage.getItem("vaucopin-lang");
  if (saved && T[saved]) return saved;
  const nav = (navigator.language || "fr").slice(0, 2);
  return T[nav] ? nav : "fr";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(detect);

  useEffect(() => {
    localStorage.setItem("vaucopin-lang", lang);
    document.documentElement.lang = lang;
    const params = new URLSearchParams(window.location.search);
    if (lang === "fr") params.delete("lang");
    else params.set("lang", lang);
    const qs = params.toString();
    window.history.replaceState(null, "", window.location.pathname + (qs ? `?${qs}` : ""));
  }, [lang]);

  const t = (path) => {
    const resolve = (obj) => path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), obj);
    return resolve(T[lang]) ?? resolve(T.fr) ?? path;
  };

  return <Ctx.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>{children}</Ctx.Provider>;
};

export const useI18n = () => useContext(Ctx);
